module.exports = __webpack_public_path__ + "img/yellow.970c6dbb.svg";